<div
  *ngIf="user"
  class="ui icon top right pointing dropdown"
  #elementRef
>
  <i
    class="tw-text-lg"
    class="fa-solid fa-gear"
  ></i>

  <div class="menu">
    <ng-container
      *ngFor="let menuItem of menuItems"
      [ngSwitch]="menuItem.type"
    >
      <a
        *ngSwitchCase="menuItemType.HUB_REDIRECT"
        [attr.href]="hubUrl + menuItem.action"
        target="_{{ menuItem.target }}"
        class="item"
      >
        <i
          [ngClass]="menuItem.icon"
          class="icon"
        ></i>
        <span class="menu-item-title">{{ menuItem.title }}</span>
      </a>

      <a
        *ngSwitchCase="menuItemType.REDIRECT"
        [attr.href]="menuItem.action"
        target="_{{ menuItem.target }}"
        class="item"
      >
        <i
          [ngClass]="menuItem.icon"
          class="icon"
        ></i>
        <span class="menu-item-title">{{ menuItem.title }}</span>
      </a>

      <a
        *ngSwitchCase="menuItemType.EVENT"
        (click)="fireEvent(menuItem.action)"
        class="item"
      >
        <i
          [ngClass]="menuItem.icon"
          class="icon"
        ></i>
        <span class="menu-item-title">{{ menuItem.title }}</span>
      </a>

      <p-divider *ngSwitchCase="menuItemType.DIVIDER" />
    </ng-container>
  </div>
</div>
